import I18n from 'components/I18n'
import Money from 'components/Money'
import messages from 'lang'
import React from 'react'

// TODO unit test!
export const getCryptoAmountError = ({ amount, cryptoCurrency, maxAmount, minAmount }) => {
  const cryptoMax = maxAmount
  const cryptoMin = minAmount

  // no input, no error
  if (amount === '') return null

  const numberAmount = Number(amount)
  if (numberAmount === 0)
    return <I18n data={messages.validation_required} field={<I18n data={messages.amount} />} />
  if (numberAmount < cryptoMin)
    return (
      <I18n
        data={messages.validation_min_amount}
        field={<I18n data={messages.amount} />}
        minAmount={<Money amount={cryptoMin} currency={cryptoCurrency} />}
      />
    )
  if (numberAmount > cryptoMax)
    return (
      <I18n
        data={messages.validation_max_amount}
        field={<I18n data={messages.amount} />}
        maxAmount={<Money amount={cryptoMax} currency={cryptoCurrency} />}
      />
    )
}
